import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useMenuLinks } from '../../hooks/useMenuLinks';
import Navigation from '../Navigation';
import styles from './index.module.scss';

export interface ExpandableMenuProps {
  isExpanded: boolean;
}

export default function ExpandableMenu(props: ExpandableMenuProps) {
  const { isExpanded } = props;

  const { t } = useTranslation();
  const links = useMenuLinks();

  return (
    <div className={cn(styles.menu, { [styles.expanded]: isExpanded })}>
      <div className={styles.menuContainer}>
        <div className={styles.menuContent}>
          <div className={styles.contentSection}>
            <h2 className={styles.title}>
              {t('informa.ping-identity.ribbon.expandable-menu.title')}
            </h2>
            <p className={styles.description}>
              {t('informa.ping-identity.ribbon.expandable-menu.description')}
            </p>
          </div>
          <Navigation links={links} />
        </div>
      </div>
    </div>
  );
}
